export default __webpack_public_path__ + "static/media/close.d84c0139.svg";